const countDownFunctionality = (el, attr) => {
    const userInputDate: string = el.getAttribute(attr);
    const countDownFrom = new Date(userInputDate).getTime();

    const timer = setInterval(() => {
        const currentTime = new Date().getTime();
        const timeDifference = countDownFrom - currentTime;

        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
            (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
            (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        el.querySelector(".num-days").innerHTML =
            days >= 0 ? days.toString() : "0";
        el.querySelector(".num-hours").innerHTML =
            hours >= 0 ? hours.toString() : "0";
        el.querySelector(".num-minutes").innerHTML =
            minutes >= 0 ? minutes.toString() : "0";
        el.querySelector(".num-seconds").innerHTML =
            seconds >= 0 ? seconds.toString() : "0";

        if (timeDifference < 0) {
            clearInterval(timer);
            el.classList.add("countdown--expired");
        }
    }, 1000);
};

export const SetTimerHandler = () => {
    const snippet = document.querySelectorAll(".countdown");

    if (!snippet) {
        return;
    }

    snippet.forEach((snip) => {
        countDownFunctionality(snip, "data-time");
    });
};
